<script>
    import { onMount } from "svelte";
    import { catalog, api_url } from "../stores.js";
    import { push } from "svelte-spa-router";
    import { fade } from "svelte/transition";
    import Information from "carbon-icons-svelte/lib/Information.svelte";
    import LogoInstagram from "carbon-icons-svelte/lib/LogoInstagram.svelte";
    import LogoLinkedin from "carbon-icons-svelte/lib/LogoLinkedin.svelte";
    import LogoTwitter from "carbon-icons-svelte/lib/LogoTwitter.svelte";
    import LogoGithub from "carbon-icons-svelte/lib/LogoGithub.svelte";
    import Email from "carbon-icons-svelte/lib/Email.svelte";
    import Help from "carbon-icons-svelte/lib/Help.svelte";
    import { Loading, Modal } from "carbon-components-svelte";
    import Info from "./Info.svelte";

    const showModel = (o) => push(`/models/${o.target.id}`);

    let y,
        downloading = false,
        open = false,
        modalTitle,
        modalMessage,
        modal_now;

    const modal = (type, title, message) => {
        modal_now = type;
        modalTitle = title;
        modalMessage = message;
        open = true; // open modal message to user
    };
    function modalAbout() {
        modal(
            "about",
            "FullControl",
            "FullControl is open-source design software created by Andrew Gleadall and Dirk Leas. It embraces the design principles of the original version ('FullControl GCode Designer'), but this second version ('FullControl') is entirely new - both technically and conceptually. This website allows anyone to use FullControl models without needing to understand how FullControl works. To create original designs in FullControl, see the GitHub repository.",
        );
    }

    onMount(async () => {
        downloading = true;
        if (!$catalog.length) {
            const response = await fetch(`${$api_url}`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    action: "catalog",
                }),
            });
            const data = await response.json();
            $catalog = data;
        }
        downloading = false;
    });
    // these variables are needed in both css and html sections
    let size = getComputedStyle(document.documentElement).getPropertyValue(
            "--size",
        ),
        border = getComputedStyle(document.documentElement).getPropertyValue(
            "--border",
        );

    // add new model steps: add id to homepage_models, placeholders -= 1, reduce all indexs for setting placeholderTitles/placeholderNotes, set countDownDate for next model,
    let homepage_models = [
            "4a0397",
            "971ff7",
            "a72616",
            "eac87f",
            "ff1d4e",
            "b70938",
            "2d37a5",
            "3bfcdb",
            "1d3528",
            "4d0e78",
            "67cf20",
            "7d3dc2",
            "ebdc86",
            "800020",
            "393a4c",
            "c5042e",
        ],
        placeholders = 12,
        placeholderTitles = Array(placeholders).fill("Coming soon"),
        placeholderNotes = Array(placeholders).fill("");
    // placeholderTitles[0] = "Release"; // this avoids a visible change when myfunc runs
    // placeholderTitles[0] = "Next model: release imminent";
    // placeholderNotes[1] = "Multi-tool demo";
    // placeholderNotes[3] = "Python FullControl available";
    // placeholderNotes[5] = "4-axis demo";
    // placeholderNotes[9] = "Users models on website";
    // placeholderNotes[10] = "5-axis demo";
    let countDownDate = new Date("Jan 08, 2025 10:00:00 UTC").getTime(); // time here should be 1hr earlier than BST (IF IN BST!)
    let now, timeleft, days, hours, minutes, seconds;
    // var myfunc = setInterval(function () {
    //     now = new Date().getTime();
    //     timeleft = countDownDate - now;
    //     days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
    //     hours = Math.floor(
    //         (timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
    //     );
    //     minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
    //     seconds = Math.floor((timeleft % (1000 * 60)) / 1000);
    //     placeholderTitles[0] = `Release\n${days}D ${hours}H ${minutes}M ${seconds}S`;
    //     if (days < 0 || (days < 1 && hours < 1)) {
    //         placeholderTitles[0] = "Release Imminent";
    //     }
    //     // placeholderTitles[0] = "Xmas Model\nComing!";
    // }, 1000);
</script>

<svelte:window bind:scrollY={y} />

<!-- some of the following code is superfluous, but kept in to be consistent with Model.svelte, so it can be pulled out as MyModal.svelte in the future -->
{#if modal_now == "about"}
    <Modal
        primaryButtonText="FullControl python GitHub repository"
        secondaryButtonText="Original website: www.fullcontrolgcode.com"
        on:submit={() =>
            window.open(
                "https://github.com/FullControlXYZ/fullcontrol",
                "_blank",
            )}
        on:click:button--secondary={() =>
            window.open("http://www.fullcontrolgcode.com", "_blank")}
        bind:open
        modalHeading={modalTitle}
        on:open
        on:close
    >
        <p>
            {modalMessage}
        </p>
    </Modal>
{:else if modal_now == "passive"}
    <Modal passiveModal bind:open modalHeading={modalTitle} on:open on:close>
        <p>
            {modalMessage}
        </p>
    </Modal>
{/if}

<body in:fade={{ delay: 500 }} out:fade|local>
    <div id="fullscreengrad" />
    <div id="modelfade" />
    <div id="about" on:click={modalAbout}>About</div>
    <div id="titlecontainer">
        {#if y < 120}
            <div id="title" in:fade|local out:fade|local>
                <h1>FullControl Design Library</h1>
            </div>
        {/if}
        {#if y < 30}
            <div id="logos" style="font-size:20px" in:fade|local out:fade|local>
                <a
                    title="Instagram"
                    href="https://www.instagram.com/fullcontrolxyz"
                    target="_blank"><LogoInstagram size={24} /></a
                >&nbsp&nbsp&nbsp
                <a
                    title="Twitter"
                    href="https://twitter.com/FullControlXYZ"
                    target="_blank"><LogoTwitter size={24} /></a
                >&nbsp&nbsp&nbsp
                <a
                    title="LinkedIn"
                    href="https://linkedin.com/in/andrew-gleadall-068587119"
                    target="_blank"><LogoLinkedin size={24} /></a
                >&nbsp&nbsp&nbsp
                <a
                    title="GitHub repo"
                    href="https://github.com/FullControlXYZ/fullcontrol"
                    target="_blank"><LogoGithub size={24} /></a
                >&nbsp&nbsp&nbsp
                <a
                    title="Reddit (help forum)"
                    href="https://reddit.com/r/fullcontrol"
                    target="_blank"><Help size={24} /></a
                >&nbsp&nbsp&nbsp
                <a
                    title="info@fullcontrol.xyz"
                    href="mailto:info@fullcontrol.xyz"
                    target="_blank"><Email size={24} /></a
                >
            </div>
        {/if}
    </div>
    {#if downloading}
        <div id="status" in:fade|local out:fade|local>
            <Loading />
        </div>
    {/if}
    <div id="gridcontainer">
        <div class="grid">
            {#each $catalog as model}
                {#if homepage_models.includes(model.id)}
                    <div class="container" height={size - 2}>
                        <p id={model.id} on:click={showModel}>{model.name}</p>
                        <info><Info text={model.description} /></info>
                        <img
                            id={model.id}
                            on:click={showModel}
                            src={"model_images/" +
                                model.id +
                                "/" +
                                model.images[0]}
                            width={size - 2 * border}
                            height={size - 2 * border}
                            alt={model.id + " - " + model.description}
                            in:fade|local
                            out:fade|local
                        />
                    </div>
                {/if}
            {/each}
            {#each Array(placeholders) as _, i}
                <div class="container_placeholder" height={size - 2}>
                    <p class="placeholdertitle" style="white-space: pre-line;">
                        {placeholderTitles[i]}
                    </p>
                    <img
                        id="placeholder"
                        src={"model_placeholder2.png"}
                        width={size - 2 * border}
                        height={size - 2 * border}
                        alt={"Model coming soon"}
                        in:fade|local
                        out:fade|local
                    />
                    <div class="grad" />
                    <p class="placeholdernote">{placeholderNotes[i]}</p>
                </div>
            {/each}
        </div>
    </div>
</body>

<svelte:head>
    <meta name="viewport" content="width=1024" />
</svelte:head>

<style>
    @import url("https://fonts.cdnfonts.com/css/mayeka-demo");
    :root {
        --size: 250;
        --gap: 30;
        --border: 1;
        --maxColumns: 3;
        --topBarHeight: 55;
    }
    :root::-webkit-scrollbar {
        width: 10px;
    }
    :root::-webkit-scrollbar-track {
        background: black;
    }
    :root::-webkit-scrollbar-thumb {
        background: #333333;
        border-radius: 10px;
    }
    :root::-webkit-scrollbar-thumb:hover {
        background: #444444;
    }
    a:link,
    a:visited {
        color: white;
    }
    body {
        font-family: "Mayeka Regular Demo", Arial, sans-serif;
        /* background-color: #222222; */
        background-color: #111111;
    }
    body * {
        user-select: none;
    }
    #fullscreengrad {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-image: linear-gradient(
            to right,
            black,
            #161616 10%,
            #161616 90%,
            black
        );
    }
    #titlecontainer {
        position: relative;
        text-align: center;
        z-index: 2;
        padding-top: calc((var(--topBarHeight) * 1px));
        padding-bottom: calc((var(--topBarHeight) * 1px));
        /* background-color: black; */
        position: fixed;
        width: 100%;
        display: block;
    }
    #title {
        display: block;
        background-color: #222222;
        position: fixed;
        padding: 10px;
        padding-left: 40px;
        padding-right: 40px;
        left: 50%;
        transform: translateX(-50%);
        border-radius: 6px;
        /* border: 1px solid #555555; */
        box-shadow:
            0 0 6px #666666,
            0 0 10px black,
            0 0 10px black;
        white-space: nowrap;
    }
    #logos {
        display: block;
        /* background-color: #222222; */
        position: fixed;
        padding-top: 90px;
        padding-left: 40px;
        padding-right: 40px;
        left: 50%;
        transform: translateX(-50%);
        /* border-radius: 6px; */
        /* border: 1px solid #555555; */
        /* text-shadow: 0 0 6px #666666, 0 0 10px grey, 0 0 10px grey; */
    }
    #about {
        font-size: medium;
        /* position: absolute; */
        float: right;
        color: rgb(171, 171, 171);
        z-index: 3;
        right: 10px;
        padding-top: 10px;
        cursor: pointer;
        position: fixed;
    }
    #gridcontainer {
        margin: auto;
        padding-left: 5%;
        padding-right: 5%;
        max-width: calc(
            (var(--size) + var(--gap)) * (var(--maxColumns) + 1) * 1px
        );
        /* background-color: #222222; */
    }
    .grid {
        padding-top: calc(((var(--gap) + 3.2 * var(--topBarHeight)) * 1px));
        display: grid;
        grid-template-columns: repeat(
            auto-fill,
            minmax(calc((var(--size) * 1px)), calc((var(--size) * 1px)))
        );
        grid-template-rows: calc((var(--size) * 1px));
        gap: calc((var(--gap) * 1px));
        margin: auto;
        justify-items: center;
        justify-content: center;
        align-content: center;
    }
    /* .grid #grad {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-image: linear-gradient(rgba(0, 0, 0, 0) 90%, black);
    } */
    .container {
        max-width: 100%;
        position: relative;
        text-align: center;
        cursor: pointer;
        border: calc((var(--border) * 1px)) solid #444444;
        border-radius: 6px;
        transform: scale(0.96);
        opacity: 1;
        transition:
            opacity 0.4s,
            transform 0.4s;
        box-shadow: 0 0 6px #444444;
    }
    .container:hover {
        transform: scale(1);
        opacity: 0.8;
    }
    .container_placeholder {
        max-width: 100%;
        position: relative;
        text-align: center;
        /* cursor: pointer; */
        border: calc((var(--border) * 1px)) solid #444444;
        border-radius: 6px;
        transform: scale(0.96);
        opacity: 1;
        transition:
            opacity 0.4s,
            transform 0.4s;
        box-shadow: 0 0 6px #444444;
    }
    .container p {
        padding-top: 6px;
        width: 75%;
        text-align: center;
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        /* shadow makes text visible even for a white bg */
        text-shadow:
            0 0 1px #888888,
            0 0 3px #888888;
    }
    .container_placeholder p {
        padding-top: 4px;
        width: 75%;
        text-align: center;
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        /* shadow makes text visible even for a white bg */
        text-shadow:
            0 0 1px #888888,
            0 0 3px #888888;
    }
    .container_placeholder .placeholdernote {
        padding-top: 4px;
        width: 90%;
        text-align: right;
        position: absolute;
        bottom: 4px;
        right: 10px;
        font-style: italic;
        font-size: small;
        color: grey;
        /* transform: translate(-50%); */
        /* shadow makes text visible even for a grey bg */
        text-shadow:
            0 0 1px #444444,
            0 0 3px #444444;
    }
    .container_placeholder .grad {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-image: linear-gradient(
            rgba(0, 0, 0, 0),
            rgba(0, 0, 0, 1) 70%
        );
    }
    .container info {
        text-align: right;
        position: absolute;
        right: -10px;
        top: 4px;
    }
    .container img {
        border-radius: 6px;
    }
</style>
